<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('publicize.videoName')" prop="videoId" >
        <!--        <a-input v-model="form.videoId" placeholder="请输入短剧id" />-->
        <a-select
            v-model="form.videoId"
            showSearch
            style="width: 100%"
            :placeholder="$t('publicize.selectVideo')"
            allow-clear
            optionFilterProp="children"
        >
          <a-select-option :value="item.id" :key="item.id" :title="item.videoName" v-for="(item,index) in listAll">
            {{item.videoName}}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('publicize.video')" prop="videoUrl" >
        <!--        <a-input v-model="form.videoUrl" placeholder="请输入短剧url" />-->
        <a-upload
            listType="picture-card"
            class="avatar-uploader"
            v-model="form.videoUrl"
            :action="`${uploadBaseUrl}/common/local/file/uploadCos`"
            :showUploadList="false"
            :beforeUpload="beforeUploadVideo"
            :customRequest="handleChange"
        >
          <video :src="form.videoUrl" v-if="form.videoUrl" width="300" height="150" controls></video>

          <!--          <img v-if="form.videoUrl" :src="form.videoUrl" alt="logo"-->
          <!--               style="height:104px;max-width:300px"/>-->
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>

            <div class="ant-upload-text">{{ $t('publicize.upload') }}</div>
            <a-progress v-if="percent>0" :percent="percent" />
          </div>
          <!--          <a-spin v-if="uploadLoading" />-->
        </a-upload>
      </a-form-model-item>
      <a-form-model-item :label="$t('publicize.sort')" prop="seq" >
        <a-input v-model="form.seq" :placeholder="$t('publicize.inputSort')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('publicize.remark')" prop="remark" >
        <a-input v-model="form.remark" :placeholder="$t('publicize.inputContent')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getPublicize, addPublicize, updatePublicize } from '@/api/video/publicize'
import {listVideo} from "@/api/video/video";
import UploadFileToVOD from "@/api/vod";
import UploadFileToOSS from "@/utils/upload-file-to-oss";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      uploadBaseUrl: process.env.VUE_APP_BASE_API,
      listAll:[],
      submitLoading: false,
      uploadLoading: false,
      percent: 0,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        videoId: null,

        videoUrl: null,

        seq: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false
    }
  },
  filters: {
  },
  created () {
    this.getGather();
  },
  computed: {
    rules() {
      return {
        videoId: [
          { required: true, message: this.$t('publicize.videoIdRequired') }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    beforeUploadVideo:function (file) {
      var fileType = file.type;
      if (fileType.indexOf('video') < 0) {
        this.$message.warning(this.$t('publicize.uploadVideoWarning'));
        this.form.videoUrl = '';
        return false
      }

      //TODO 驗證文件大小
    },

    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading = true;
        return;
      }
      let that = this
      that.form.videoUrl = ""
      new UploadFileToVOD([info.file], {
        success: function (fileName) {

          that.form.videoUrl = fileName[0];//文件名
          that.uploadLoading = false;
        },
        vProgress:function (val) {
          console.log(val)
          that.percent=val*100

        }
      });
      that.uploadLoading = false;
      this.percent=0


    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    getGather() {
      listVideo().then(res => {
        this.listAll = res.data;
      })
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        videoId: null,
        videoUrl: null,
        seq: null,
        createTime: null,
        remark: null,
      }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.form = {
        id: null,

            videoId: null,

            videoUrl: null,

            seq: null,

            createTime: null,

            remark: null,

      }
      this.open = true
      this.formTitle = this.$t('common.add')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getPublicize({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('common.edit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updatePublicize(this.form).then(response => {
              this.$message.success(
                this.$t('common.updateSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addPublicize(this.form).then(response => {
              this.$message.success(
                this.$t('common.addSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
